
import { useState } from 'react';

export const useImageHandling = () => {
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string>('');

  // Handle file upload for doctor image
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      
      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUrlChange = (e: React.ChangeEvent<HTMLInputElement>, updateFormState: (name: string, value: string) => void) => {
    setImageFile(null);
    setImagePreview(e.target.value);
    updateFormState(e.target.name, e.target.value);
  };

  return {
    imageFile,
    setImageFile,
    imagePreview,
    setImagePreview,
    handleFileChange,
    handleImageUrlChange,
  };
};
